module.exports = __webpack_public_path__ + "static/media/prawy-gora-geo.5547dd31.svg";